export default {
  READY: 0,
  LOADING: 1,
  ERROR: 2
}